import axios from "axios";
import UserService from "@/services/UserService";

const AuthenticationService = {

	getTokensFromAuthorizationCode(authCode) {
    const request = new URLSearchParams({
      grant_type: "authorization_code",
      redirect_uri: import.meta.env.VITE_URL,
      client_id: import.meta.env.VITE_AWS_COGNITO_CLIENT_ID,
      client_secret: import.meta.env.VITE_AWS_COGNITO_CLIENT_SECRET,
      code: authCode
    }).toString();
    const options = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };
    return axios.post(import.meta.env.VITE_AWS_COGNITO_URL + "/oauth2/token", request, options).then(response => { 
      this.saveTokensToLocalStorage(response.data);
      return response;
    }).catch(error => this.redirectToSignInURL());
  },

  getTokensFromRefreshToken(refreshToken) {
    const request = new URLSearchParams({
      grant_type: "refresh_token",
      client_id: import.meta.env.VITE_AWS_COGNITO_CLIENT_ID,
      client_secret: import.meta.env.VITE_AWS_COGNITO_CLIENT_SECRET,
      refresh_token: refreshToken
    }).toString();
    const options = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };
    return axios.post(import.meta.env.VITE_AWS_COGNITO_URL + "/oauth2/token", request, options).then(response => {
      this.saveTokensToLocalStorage({ ...response.data, refresh_token: refreshToken });
      UserService.logSecurityEvent({ event: "TOKEN_REFRESH" });
      return response;
    }).catch(error => this.redirectToSignInURL());
  },

  saveTokensToLocalStorage(tokenData) {
    localStorage.setItem("authTokens", JSON.stringify({
      access_token: tokenData.access_token,
      id_token: tokenData.id_token,
      refresh_token: tokenData.refresh_token,
      expiration_relative_to_system_date_time: Math.floor(Date.now() / 1000) + tokenData.expires_in
    }));
  },

  removeTokensFromLocalStorage() {
    localStorage.removeItem("authTokens");
  },

  redirectToSignInURL() {
    if (![ "/session-expired", "/signed-out" , "/error/forbidden" ].includes(window.location.pathname)) {
      localStorage.setItem("redirect_uri", window.location.pathname + window.location.search);
    }
    window.location = `${import.meta.env.VITE_AWS_COGNITO_URL}/login?client_id=${import.meta.env.VITE_AWS_COGNITO_CLIENT_ID}&response_type=code&scope=openid&redirect_uri=${import.meta.env.VITE_URL}`;
  },

  redirectToSignOutURL() {
    window.location = `${import.meta.env.VITE_AWS_COGNITO_URL}/logout?client_id=${import.meta.env.VITE_AWS_COGNITO_CLIENT_ID}&response_type=code&scope=openid&redirect_uri=${import.meta.env.VITE_URL}`;
  },

  redirectToForgotPasswordURL() {
    window.location = `${import.meta.env.VITE_AWS_COGNITO_URL}/forgotPassword?client_id=${import.meta.env.VITE_AWS_COGNITO_CLIENT_ID}&response_type=code&scope=openid&redirect_uri=${import.meta.env.VITE_URL}`;
  },

  secondsUntilAccessTokenExpires() {
    if (localStorage.getItem("authTokens")) {
      return Math.floor(JSON.parse(localStorage.getItem("authTokens")).expiration_relative_to_system_date_time - (Date.now() / 1000));
    } else {
      return 0;
    }
  }

}

export default AuthenticationService;